import React, {useReducer, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye, faUnlockAlt, faUser} from '@fortawesome/free-solid-svg-icons';
import {Button, Col, Form, InputGroup, Modal, Row} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';
import {useHistory} from 'react-router-dom';

import Utils from '../services/Utils';
import API from '../services/API';
import {usePlan} from '../services/PlanContext';
import {DAYS_BORDER_COLOR, NAME} from '../services/constants';

// Modale de bienvenue — extraite de l'ancien Navbar.js.
// Déclenchée par le Sidebar à la 1ère ouverture (via GET /admin/me/profile-status :
// le flag profile_completed_at reste NULL tant que l'utilisateur n'a pas complété
// son profil via cette modale).

const formReducer = (state, event) => {
  if (event.value !== undefined) {
    return {...state, [event.name]: event.value};
  }
  return event;
};

export default (props) => {
  const {intl, show, onClose} = props;
  const history = useHistory();
  const {plan} = usePlan();
  const [formData, setFormData] = useReducer(formReducer, {});
  const [showPassword, setShowPassword] = useState(false);
  const passwordInputType = showPassword ? 'text' : 'password';
  const passwordIconColor = showPassword ? DAYS_BORDER_COLOR : '';

  const handleChange = (event) => {
    setFormData({name: event.target.id, value: event.target.value});
  };

  const handleClickMySubscription = () => {
    API.getStripePortalUrl(history).then(response => {
      if (response && response.data.success === true) {
        window.location.replace(response.data.data);
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    API.postNewProfile(history, formData).then(response => {
      if (response && response.data.success === true) {
        Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'SAVED_CHANGES'}));
        localStorage.setItem(NAME, formData.companyName);
        onClose && onClose();
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  };

  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={() => { /* not dismissible */ }}>
      <Modal.Header>
        <Modal.Title className="h6"><FormattedMessage id="WELCOME"/></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <FormattedMessage id="THANK_YOU_BEFORE_STARTING"/>
          {plan !== 'FREE' && (
            <>
              <br/><br/>
              <Button variant="light" onClick={handleClickMySubscription}>
                <FormattedMessage id="UPDATE_MY_BILLING_INFORMATION"/>
              </Button>
            </>
          )}
        </div>
        <br/>
        <div className="text-center">
          <FormattedMessage id="TELL_US_COMPANY_AND_PASSWORD"/>
        </div>
        <br/>
        <Form id="welcome-form" onSubmit={handleSubmit}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label><FormattedMessage id="BUSINESS_NAME"/></Form.Label>
                <InputGroup>
                  <InputGroup.Text><FontAwesomeIcon icon={faUser}/></InputGroup.Text>
                  <Form.Control required type="text" id="companyName" name="organization" autoComplete="organization"
                                onChange={handleChange} value={formData.companyName || ''}/>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label><FormattedMessage id="NEW_PASSWORD"/></Form.Label>
                <InputGroup>
                  <InputGroup.Text><FontAwesomeIcon icon={faUnlockAlt}/></InputGroup.Text>
                  <Form.Control required type={passwordInputType} id="newPassword" name="newPassword" autoComplete="new-password" minLength="8"
                                onChange={handleChange} value={formData.newPassword || ''}/>
                  <InputGroup.Text onClick={() => setShowPassword(!showPassword)}
                                   style={{borderRight: '1px solid #D1D7E0'}}>
                    <FontAwesomeIcon color={passwordIconColor} icon={faEye}/>
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" type="submit" form="welcome-form">
          <FormattedMessage id="I_FINISHED"/>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
